import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import { selectCurrentLocation } from '../../../stores/locations/locations.selector';
import { selectCurrentRoom } from '../../../stores/rooms/rooms.selector';

import * as fromRoomConfigurations from './room-configuration.reducer';

export interface State {
  roomConfigurations: fromRoomConfigurations.RoomConfigurationsState;
}

export const reducers: ActionReducerMap<State> = {
  roomConfigurations: fromRoomConfigurations.roomConfigurationsReducer,
};

export const selectRoomConfigurationsState = createFeatureSelector<fromRoomConfigurations.RoomConfigurationsState>(
  fromRoomConfigurations.inroomRoomConfigurationsKey
);

export const selectRoomConfigurationsEntities = createSelector(
  selectRoomConfigurationsState,
  fromRoomConfigurations.selectRoomConfigurationEntities
);

export const selectCurrentRoomConfiguration = createSelector(
  selectRoomConfigurationsEntities,
  selectCurrentLocation,
  selectCurrentRoom,
  (entities, location, room) => (location && room ? entities[`${location.HotelCode}-${room.Room ?? ''}`] : null) // Can't set Room to required, because it is a model from IReckon.
);
